"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ComponentRowDual7030.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRowDual7030 = function ComponentRowDual7030(props) {
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('component-row-dual', props.customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(bemClasses('component-container-left'), " container-with-shadow")
  }, props.component1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(bemClasses('component-container-right'), " container-with-shadow")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('component-container-right-content')
  }, props.component2)));
};
var _default = exports["default"] = ComponentRowDual7030;